/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_scatter_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pairs of numbers: the first column is the x-coordinate and the second is the y-coordinate. Each row becomes one point.`)
};

const es_scatter_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pares de números: la primera columna es la coordenada x y la segunda es la coordenada y. Cada fila se convierte en un punto.`)
};

const de_scatter_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlenpaare: Die erste Spalte ist die x-Koordinate und die zweite die y-Koordinate. Jede Zeile wird zu einem Punkt.`)
};

const nl_scatter_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paren getallen: de eerste kolom is de x-coördinaat en de tweede is de y-coördinaat. Elke rij wordt één punt.`)
};

const fr_scatter_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des paires de nombres : la première colonne est la coordonnée x et la seconde la coordonnée y. Chaque ligne devient un point.`)
};

const it_scatter_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coppie di numeri: la prima colonna è la coordinata x e la seconda è la coordinata y. Ogni riga diventa un punto.`)
};

const pt_br2_scatter_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pares de números: a primeira coluna é a coordenada x e a segunda é a coordenada y. Cada linha se torna um ponto.`)
};

const pt_scatter_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pares de números: a primeira coluna é a coordenada x e a segunda é a coordenada y. Cada linha torna-se um ponto.`)
};

const ja_scatter_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値のペア: 最初の列がx座標、2番目の列がy座標です。各行が1つの点になります。`)
};

const zh_scatter_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成对的数字：第一列为 x 坐标，第二列为 y 坐标。每行成为图上的一个点。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const scatter_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.scatter_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("scatter_faq_a1", locale)
	if (locale === "en") return en_scatter_faq_a1(inputs)
	if (locale === "es") return es_scatter_faq_a1(inputs)
	if (locale === "de") return de_scatter_faq_a1(inputs)
	if (locale === "nl") return nl_scatter_faq_a1(inputs)
	if (locale === "fr") return fr_scatter_faq_a1(inputs)
	if (locale === "it") return it_scatter_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_scatter_faq_a1(inputs)
	if (locale === "pt") return pt_scatter_faq_a1(inputs)
	if (locale === "ja") return ja_scatter_faq_a1(inputs)
	return zh_scatter_faq_a1(inputs)
};